(function () {
  var grid = document.querySelector('[data-collection-grid]');
  if (!grid) return;

  var finder = document.querySelector('[data-collection-finder]');
  var items = grid.querySelectorAll('[data-collection-item]');
  var filters = document.querySelectorAll('[data-collection-filter]');
  var empty = document.querySelector('[data-collection-empty]');
  var results = document.querySelector('[data-collection-results]');
  var educationPanel = document.querySelector('[data-filter-education]');
  var educationHeadline = document.querySelector('[data-education-headline]');
  var educationIntro = document.querySelector('[data-education-intro]');
  var educationDisclaimer = document.querySelector('[data-education-disclaimer]');
  var activeBar = document.querySelector('[data-finder-active]');
  var activeLabel = document.querySelector('[data-finder-active-label]');
  var mobileLabel = document.querySelector('[data-finder-mobile-label]');
  var drawer = document.querySelector('[data-finder-drawer]');
  var openBtn = document.querySelector('[data-finder-open]');
  var closeBtns = document.querySelectorAll('[data-finder-close]');
  var drawerTabs = document.querySelectorAll('[data-finder-tab]');
  var drawerPanels = document.querySelectorAll('[data-finder-panel]');
  var educationData = null;
  var mobileMq = window.matchMedia('(max-width: 768px)');

  function locale() {
    if (!educationPanel) return 'en';
    return educationPanel.getAttribute('data-locale') === 'es' ? 'es' : 'en';
  }

  function isMobile() {
    return mobileMq.matches;
  }

  function loadEducation() {
    if (!educationPanel || educationData) return Promise.resolve(educationData);
    var url = educationPanel.getAttribute('data-education-url');
    if (!url) return Promise.resolve(null);
    return fetch(url)
      .then(function (res) {
        return res.json();
      })
      .then(function (data) {
        educationData = data;
        return data;
      })
      .catch(function () {
        return null;
      });
  }

  function renderEducation(filter) {
    if (!educationPanel || !educationData) return;

    if (filter === 'all') {
      educationPanel.hidden = true;
      return;
    }

    var copy = educationData.filters && educationData.filters[filter];
    if (!copy) {
      educationPanel.hidden = true;
      return;
    }

    var lang = locale();
    educationHeadline.textContent = lang === 'es' ? copy.headline_es : copy.headline_en;
    educationIntro.textContent = lang === 'es' ? copy.intro_es : copy.intro_en;
    educationDisclaimer.textContent =
      lang === 'es' ? educationData.disclaimer_es : educationData.disclaimer_en;

    educationPanel.hidden = false;
  }

  function filterLabel(active, activeEl) {
    if (active === 'all') return '';
    if (activeEl) {
      var cardLabel = activeEl.querySelector('.collection-finder-card__label');
      if (cardLabel) return cardLabel.textContent.trim();
      return activeEl.textContent.trim();
    }
    return active;
  }

  function syncDrawerTab(tier) {
    if (!tier || tier === 'all') return;
    drawerTabs.forEach(function (tab) {
      var on = tab.getAttribute('data-finder-tab') === tier;
      tab.classList.toggle('is-active', on);
      tab.setAttribute('aria-selected', on ? 'true' : 'false');
    });
    drawerPanels.forEach(function (panel) {
      var on = panel.getAttribute('data-finder-panel') === tier;
      panel.classList.toggle('is-active', on);
      panel.hidden = !on;
    });
  }

  var lastFinderFocus = null;

  function openDrawer() {
    if (!drawer) return;
    lastFinderFocus = document.activeElement;
    drawer.hidden = false;
    drawer.setAttribute('aria-hidden', 'false');
    document.body.classList.add('finder-drawer-open');
    if (openBtn) openBtn.setAttribute('aria-expanded', 'true');

    var panel = drawer.querySelector('.collection-finder__drawer-panel');
    if (panel && window.DisuriA11y) {
      window.DisuriA11y.trapFocus(panel);
    }
    var focusTarget = drawer.querySelector('.collection-finder__drawer-close');
    if (focusTarget && typeof focusTarget.focus === 'function') {
      focusTarget.focus();
    }
  }

  function closeDrawer() {
    if (!drawer) return;
    drawer.hidden = true;
    drawer.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('finder-drawer-open');
    if (openBtn) openBtn.setAttribute('aria-expanded', 'false');
    if (lastFinderFocus && typeof lastFinderFocus.focus === 'function') {
      lastFinderFocus.focus();
    }
  }

  function applyFilter(filter, sourceEl) {
    var active = filter || 'all';
    var visible = 0;
    var activeEl = sourceEl || null;

    items.forEach(function (item) {
      var tags = (item.getAttribute('data-filter-tags') || '').trim();
      var tagList = tags ? tags.split(/\s+/) : [];
      var show = active === 'all' || tagList.indexOf(active) !== -1;
      item.hidden = !show;
      item.classList.toggle('is-filter-hidden', !show);
      if (show) visible += 1;
    });

    filters.forEach(function (el) {
      var elFilter = el.getAttribute('data-collection-filter');
      var isActive = elFilter === active;
      el.classList.toggle('active', isActive);
      el.classList.toggle('is-active', isActive);
      el.setAttribute('aria-pressed', isActive ? 'true' : 'false');
      if (isActive && !activeEl) activeEl = el;
    });

    grid.setAttribute('data-filter-active', active);

    var label = filterLabel(active, activeEl);
    if (activeBar && activeLabel) {
      if (active === 'all') {
        activeBar.hidden = true;
      } else {
        activeLabel.textContent = label;
        activeBar.hidden = false;
      }
    }

    if (mobileLabel) {
      mobileLabel.textContent =
        active === 'all'
          ? mobileLabel.getAttribute('data-default-label') ||
            mobileLabel.textContent
          : label;
    }

    if (activeEl && activeEl.getAttribute('data-finder-tier')) {
      syncDrawerTab(activeEl.getAttribute('data-finder-tier'));
    }

    if (empty) {
      empty.hidden = visible > 0;
    }

    loadEducation().then(function () {
      renderEducation(active);
    });

    if (window.history && window.history.replaceState) {
      var url = new URL(window.location.href);
      if (active === 'all') {
        url.searchParams.delete('filter');
      } else {
        url.searchParams.set('filter', active);
      }
      window.history.replaceState({}, '', url);
    }

    if (isMobile() && active !== 'all') {
      closeDrawer();
      if (results) {
        results.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    }
  }

  filters.forEach(function (el) {
    el.addEventListener('click', function (event) {
      event.preventDefault();
      applyFilter(el.getAttribute('data-collection-filter'), el);
    });
  });

  if (openBtn) {
    if (mobileLabel && !mobileLabel.getAttribute('data-default-label')) {
      mobileLabel.setAttribute('data-default-label', mobileLabel.textContent.trim());
    }
    openBtn.addEventListener('click', openDrawer);
  }

  closeBtns.forEach(function (btn) {
    btn.addEventListener('click', closeDrawer);
  });

  drawerTabs.forEach(function (tab) {
    tab.addEventListener('click', function () {
      var tier = tab.getAttribute('data-finder-tab');
      syncDrawerTab(tier);
    });
  });

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape' && drawer && !drawer.hidden) {
      closeDrawer();
    }
  });

  var params = new URLSearchParams(window.location.search);
  var initial = params.get('filter') || 'all';
  applyFilter(initial);
  grid.setAttribute('data-filter-ready', 'true');
})();
